import React from 'react'
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import upload_icon from '../../images/managedata/upload.svg'
import doenloadsam_icon from '../../images/managedata/download_sam.svg'
import download_icon from '../../images/managedata/download.svg'
import { Box, Button, FormControl, InputLabel, Select as MuiSelect, MenuItem, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next';
export default function ImportExport() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const { t } = useTranslation()
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                position: 'relative',
                gap: { xs: '15px', md: '30px' },
                borderRadius: '10px',
                borderWidth: '1px',
                margin: { xs: '10px', sm: '20px 40px' },
                background: '#FFFFFF',
                border: '1px solid #A5DCF3',
                boxShadow: '-2px 2px 5px 0px rgba(0,0,0,0.25)',
                padding: { xs: '15px', sm: '20px' }
            }}
        >
            {/* Import Section */}
            <Box sx={{ width: "100%", mb: { xs: 2, md: 0 } }}>
                <Box sx={{
                    height: { xs: '45px', sm: '52px' },
                    borderRadius: '8px',
                    padding: '12px 24px',
                    background: '#647490',
                    boxShadow: '-2px 2px 5px 0px rgba(0,0,0,0.40)',
                    fontFamily: "Roboto",
                    fontWeight: "600",
                    fontSize: { xs: '20px', sm: '24px' },
                    color: "#FFFFFF",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {t("importData")}
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'stretch', sm: 'flex-end' },
                        gap: { xs: '15px', sm: '24px' },
                        marginTop: 2,
                        padding: '0px 10px',
                    }}
                >
                    <Box sx={{
                        width: { xs: '100%', sm: '50%' },
                        mb: { xs: '10px', sm: 0 }
                    }}>
                        <InputLabel
                            sx={{
                                fontFamily: 'Roboto',
                                fontWeight: 500,
                                fontSize: { xs: '18px', sm: '20px' },
                                color: '#1F242E',
                                mb: 1,
                                position: 'static'
                            }}
                        >
                            {t("section")}
                        </InputLabel>
                        <FormControl fullWidth>
                            <MuiSelect
                                id="section-select"
                                displayEmpty
                                sx={{
                                    width: '100%',
                                    height: 55,
                                    borderRadius: '16px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderWidth: '2px',
                                        borderColor: '#183059'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderWidth: '2px',
                                        borderColor: '#183059'
                                    }
                                }}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={10}>Option 1</MenuItem>
                                <MenuItem value={20}>Option 2</MenuItem>
                                <MenuItem value={30}>Option 3</MenuItem>
                            </MuiSelect>
                        </FormControl>
                    </Box>

                    <Button
                        variant="outlined"
                        sx={{
                            height: 56,
                            width: { xs: '100%', sm: '178px' },
                            borderRadius: '8px',
                            borderWidth: '2px',
                            padding: '16px 24px',
                            border: '2px solid #20A8E0',
                            fontFamily: 'Roboto',
                            fontWeight: 500,
                            fontSize: { xs: '18px', sm: '20px' },
                            color: '#20A8E0',
                            textTransform: 'none',
                            '&:hover': {
                                borderWidth: '2px',
                                borderColor: '#20A8E0',
                            }
                        }}
                    >
                        <InsertLinkIcon sx={{ transform: 'rotate(-90deg)', mr: 1 }} />  {t("attachFile")}
                    </Button>
                </Box>

                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { xs: '10px', sm: '20px' },
                    marginTop: '20px'
                }}>
                    <Button
                        sx={{
                            height: 56,
                            width: { xs: '100%', sm: 'auto' },
                            borderRadius: '8px',
                            padding: '16px 24px',
                            background: '#F9E719',
                            border: '1px solid #414958',
                            fontFamily: 'Roboto',
                            fontWeight: 500,
                            fontSize: { xs: '18px', sm: '20px' },
                            color: '#1F242E',
                            textTransform: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px'
                        }}
                    >
                        <img src={upload_icon} alt="Upload" style={{ width: '24px', height: '24px' }} /> {t("upload")}
                    </Button>
                    <Button
                        sx={{
                            width: { xs: '100%', sm: 'auto' },
                            fontFamily: 'Roboto',
                            fontWeight: 500,
                            fontSize: { xs: '16px', sm: '16px' },
                            color: '#20A8E0',
                            textTransform: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px'
                        }}
                    >
                        <img src={doenloadsam_icon} alt="Download Sample" style={{ width: '24px', height: '24px' }} />  {t("downloadSampleFormat")}
                    </Button>
                </Box>
            </Box>

            {/* Export Section */}
            <Box sx={{ width: "100%" }}>
                <Box sx={{
                    height: { xs: '45px', sm: '52px' },
                    borderRadius: '8px',
                    padding: '12px 24px',
                    background: '#647490',
                    boxShadow: '-2px 2px 5px 0px rgba(0,0,0,0.40)',
                    fontFamily: "Roboto",
                    fontWeight: "600",
                    fontSize: { xs: '20px', sm: '24px' },
                    color: "#FFFFFF",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {t("exportData")}
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: 2,
                        padding: '0px 10px',
                    }}
                >
                    <Box>
                        <InputLabel
                            sx={{
                                fontFamily: 'Roboto',
                                fontWeight: 500,
                                fontSize: { xs: '18px', sm: '20px' },
                                color: '#1F242E',
                                mb: 1,
                                position: 'static'
                            }}
                        >
                            {t("section")}
                        </InputLabel>
                        <FormControl fullWidth>
                            <MuiSelect
                                id="export-section-select"
                                displayEmpty
                                sx={{
                                    width: '100%',
                                    height: 55,
                                    borderRadius: '16px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderWidth: '2px',
                                        borderColor: '#183059'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderWidth: '2px',
                                        borderColor: '#183059'
                                    }
                                }}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={10}>Option 1</MenuItem>
                                <MenuItem value={20}>Option 2</MenuItem>
                                <MenuItem value={30}>Option 3</MenuItem>
                            </MuiSelect>
                        </FormControl>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        marginTop: '20px'
                    }}>
                        <Button
                            sx={{
                                height: 56,
                                width: { xs: '100%', sm: 'auto' },
                                borderRadius: '8px',
                                padding: '16px 24px',
                                background: '#F9E719',
                                border: '1px solid #414958',
                                fontFamily: 'Roboto',
                                fontWeight: 500,
                                fontSize: { xs: '18px', sm: '20px' },
                                color: '#1F242E',
                                textTransform: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px'
                            }}
                        >
                            <img src={download_icon} alt="Download" style={{ width: '24px', height: '24px' }} />  {t("download")}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}